import React, { useEffect, useState } from "react";
import { Card, Button, Form, Col, Collapse, Row, Alert } from "react-bootstrap";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";
import CnpOptions from "./CnpOptions";

interface IProps {
    isSectionOpen: boolean;
    cnpType: number;
    certificationName: string
    onContinue: (cnpType: number) => void;
    onOpen: () => void;
    disabled: boolean;
    isLoading?: boolean;
}

export function CnpSection(props: IProps) {

    const [openCollapse, setOpenCollapse] = useState<boolean>(props.isSectionOpen);
    const [cnpType, setCnpType] = useState<number>(props.cnpType);
    const [isValid, setIsValid] = useState<boolean>(true);

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (validateSelection(cnpType)) {
            props.onContinue(cnpType);
        }
    }

    const validateSelection = (selection: number) => {
        if (!selection) {
            setIsValid(false)
            return false;
        }
        return true;
    }

    const updateCnpType = (updatedCnpType: number) => {
        setCnpType(updatedCnpType);
    }

    useEffect(() => {
        setOpenCollapse(props.isSectionOpen);
    }, [props.isSectionOpen]);

    useEffect(() => {
        if (openCollapse) props.onOpen();
    }, [openCollapse]);

    return (
        <Card className="mb-4" border="pp-secondary-grey">
            <Card.Body>
                <Card.Title className="mb-0 font-weight-bolder" onClick={() => {if (!props.disabled) setOpenCollapse(!openCollapse)}}>
                    <span className={`text-pp-primary ${props.disabled && 'pp-disabled'}`}><i className="font-weight-bolder las la-angle-down"></i> Focus</span>
                </Card.Title>
                <Collapse in={openCollapse}>
                    <Row className="mt-3">
                        <Col xs={12} md={8} lg={6} xl={6}>
                            <Form noValidate onSubmit={(e) => onSubmit(e)}>
                                <CnpOptions cnpType={cnpType} cnpTypeUpdated={updateCnpType} />
                                {!isValid &&
                                    <Alert className="pp-font-size-smaller" variant="pp-alert-danger">
                                        <p>You must select a {props.certificationName} focus</p>
                                    </Alert>
                                }
                                {props.isLoading ? <AbpnSpinner /> : <Button type="submit" variant="pp-primary">Continue</Button>}
                            </Form>
                        </Col>
                    </Row>
                </Collapse>
            </Card.Body>
        </Card>
    );
}
export default CnpSection;